import React, { memo } from 'react';
import { ZapIcon, EyeIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-16 md:py-24 bg-[#1e293b] relative overflow-hidden" data-id="element-142">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-teal-500/10 rounded-full blur-[80px] -translate-y-1/2" data-id="element-143"></div>
      <div className="absolute top-1/2 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-[80px] -translate-y-1/2" data-id="element-144"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-145">
        <div className="text-center mb-10" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-147">
            La Solución:{' '}
            <span className="text-teal-400" data-id="element-148">Visual Linkage System (VLS)</span>
          </h2>
        </div>

        <div className="bg-slate-900/80 p-8 md:p-12 rounded-3xl border border-teal-900/50 shadow-2xl relative" data-id="element-149">
          <ZapIcon className="absolute top-0 right-0 w-32 h-32 text-teal-500/5 -translate-y-1/4 translate-x-1/4" data-id="element-150" />

          <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed relative z-10" data-id="element-151">
            <p data-id="element-152">
              En lugar de confiar en la memoria interna (que siempre falla),
              convertimos tu hogar en un tablero de control físico.
            </p>
            <div className="flex items-start gap-4 bg-teal-950/30 p-6 rounded-xl border border-teal-900/50" data-id="element-153">
              <EyeIcon className="w-8 h-8 text-teal-400 flex-shrink-0 mt-1" data-id="element-154" />
              <p data-id="element-155">
                Usamos señales visuales de alta visibilidad y "semáforos de
                energía" que comunican el estado de cada persona sin necesidad
                de abrir la boca.
              </p>
            </div>
            <p className="font-semibold text-white text-center pt-4 text-xl md:text-2xl" data-id="element-156">
              No es una agenda; es un sistema de soporte externo para que el
              amor sobreviva a la convivencia.
            </p>
          </div>
        </div>
      </div>
    </section>;
}